module.exports = {"meta":{"count":1,"average":5,"reviewed":1,"limit":5,"sids":["PIKBCH"],"averageAsInteger":5,"averageAsPercentage":100},"reviews":{"3886012":{"cid":"3886012","comment":"Fantastic service would highly recommend","ip_address":"172.22.2.77","sid":"PIKBCH","comment_date":"2022-08-02 00:00:00","status":"1","score":"5","name":"Mrs Lennon","count":"0","total":"0","useful":"0","brand":"AP","travelled_with":"","usefulPercentage":"0","bookAgain":"","rating":"10","priority":" h1","product_name":"Adamton Country House"}}}


//////////////////
// WEBPACK FOOTER
// ./config/exports/reviews/hotels/PIK.json
// module id = 175
// module chunks = 119